export default {
  key: 'returnUrl',
}
